"use strict";
/**
 * https://www.figma.com/file/NDYFGMfDaxqqY41C55RDgl/%F0%9F%90%A5-NEW-DESIGN-SYSTEM?node-id=8468%3A42375&t=kbaOdKt8XAKIaQfg-1
 */
Object.defineProperty(exports, "__esModule", { value: true });
const colors_1 = require("../colors");
const common_1 = require("../tokens/common");
const checkboxTokens = {
    'checkbox-border': (0, colors_1.getColorValue)('grey.600'),
    'checkbox-border-active': (0, colors_1.getColorValue)('grey.800'),
    'checkbox-border-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'checkbox-border-invalid': (0, common_1.getCommonTokenValue)('error'),
    'checkbox-icon': (0, colors_1.getColorValue)('transparent'),
    'checkbox-icon-active': (0, colors_1.getColorValue)('grey.800'),
    'checkbox-icon-disabled': (0, common_1.getCommonTokenValue)('disabled'),
    'checkbox-icon-invalid': (0, common_1.getCommonTokenValue)('error'),
};
exports.default = checkboxTokens;
